export interface PersonInfoData {
  personSk?: string;
}

export interface SearchStudentDetails {
  firstName?: string;
  lastName?: string;
  email?: string;
  loginId?: string;
}

export interface SubmitCaseAssignData {
  studentSk?: number | string;
  personInfo?: PersonInfoData;
  searchStudentDetails?: SearchStudentDetails;
}

export class SubmitCaseAssignModel {
  studentSk: number | string;
  personInfo: PersonInfo;

  constructor(data: SubmitCaseAssignData) {
    //TODO:We need to add types for the api endpoints, once added we need to add the types to the constructor method

    this.studentSk = data?.studentSk;
    this.personInfo = new PersonInfo(
      data?.personInfo,
      data?.searchStudentDetails
    );
  }
}

export class PersonInfo {
  firstName: string;
  lastName: string;
  email: string;
  personSk: string;
  userName: string;
  constructor(data: PersonInfoData, details: SearchStudentDetails) {
    //TODO:We need to add types for the api endpoints, once added we need to add the types to the constructor method
    this.firstName = details?.firstName;
    this.lastName = details?.lastName;
    this.email = details?.email;
    this.personSk = data?.personSk;
    this.userName = details?.loginId;
  }
}
